import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-mlp-evb-anderer-message',
  imports: [MatIcon],
  template: `
    <div
      data-testid="evb-anderer-message"
      class="flex items-start gap-4 rounded-lg border border-cp-primary-100 p-6"
    >
      <mat-icon svgIcon="cp-info" class="!size-6 shrink-0" />
      <p class="m-0 text-base leading-6 text-cp-primary-100">
        Leider können wir nur Tarife der gelisteten Versicherungen anbieten, bitte wende dich an den
        MLP Kfz-Service. Nutze hierzu das Kontaktformular auf
        <a
          href="https://www.kfz-mlp.de"
          target="_blank"
          rel="noopener noreferrer"
          class="underline font-medium"
          >www.kfz-mlp.de</a
        >.
      </p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MlpEvbAndererMessageComponent {}
